import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { stockAssDetailsReportFormIsOpen, stockAssDetailsSummaryFilters } from "../@signals"


export default function useStockAssDetailsReportForm() {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])
    const conditions = useSignal([])
    const streetDateFilter = useSignal('')

    const resetFormData = () => {
        nameReport.value = ''
        frequency.value = null
        emailsReport.value = [userEmail]
        conditions.value = []
        streetDateFilter.value = ''
    }

    const handleOpenForm = () => {
        stockAssDetailsReportFormIsOpen.value = true
    }

    const handleSendToBack = () => {
        let apiUrl =`${WEBBACK_V2_API}/reports/create`

        if (frequency.value === 'now') {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: 'stockDetails',
            conditions: {'stockStatus': conditions.value, 'streetDate': streetDateFilter.value || null},
            filters: {
                country: stockAssDetailsSummaryFilters.value.country, 
                retailer: stockAssDetailsSummaryFilters.value.retailer,
                brand: stockAssDetailsSummaryFilters.value.brand, 
                skuGroup: stockAssDetailsSummaryFilters.value.skuGroup,
                sku: stockAssDetailsSummaryFilters.value.sku, 
                category: stockAssDetailsSummaryFilters.value.category,
                id_customer: userCustomer
            }
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport,
        conditions: conditions,
        streetDateFilter: streetDateFilter
    }
}
